import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { getLatestExportableBillingCycle } from '@/backoffice/features/data-exports/utils/latest-exportable-billing-cycle';
import { FormMonthYearPicker } from '@/shared/components/ui/form/components/form-date-time-picker/variants/form-month-year-picker';
import { FormSelect } from '@/shared/components/ui/form/components/form-select/form-select';
import { Submit } from '@/shared/components/ui/form/components/submit/submit';
import { FormContent } from '@/shared/components/ui/form/form-content';
import { FormContainer } from '@/shared/components/ui/form/form.styled';
import { SelectDateTrigger } from '@/shared/components/ui/month-year-select/month-year-select.styled';
import { useDateUtils } from '@/shared/hooks/use-date-utils/use-date-utils';

import {
  TSewBillingCycleExportFormProps,
  TSewBillingCycleExportInputSchema,
} from './sew-billing-cycle-export.types';

export const SewBillingCycleExportForm: React.FC<
  TSewBillingCycleExportFormProps
> = ({ handleClose, regionOptions }) => {
  const { t } = useTranslation();
  const { formatLocalTime } = useDateUtils();

  return (
    <FormContainer>
      <FormContent $overflowVisible>
        <FormMonthYearPicker<TSewBillingCycleExportInputSchema>
          name="billingCycleReferenceTs"
          required
          dateTimePickerProps={{
            maxDate: dayjs.utc(getLatestExportableBillingCycle()),
          }}
          label={t('common:period')}
          triggerElement={(value) => (
            <SelectDateTrigger variant="primary" $hasValue={!!value}>
              {value
                ? formatLocalTime(value, 'UTC', 'MMMM yyyy')
                : t('billing:select_period')}
            </SelectDateTrigger>
          )}
        />
        {regionOptions && (
          <FormSelect<TSewBillingCycleExportInputSchema>
            name="region"
            required
            label={t('backoffice:sew.onboarding.region')}
            options={regionOptions}
          />
        )}
      </FormContent>
      <Submit submitButtonLabel={t('common:download')} onClose={handleClose} />
    </FormContainer>
  );
};
